import axios from 'axios'
import { BUSINESS_ACTIVITIES_ENDPOINT } from '../../../../../../utility/SourceAPI'


export const fetchBusinessActivities = async () => {
    const response = await axios.get(BUSINESS_ACTIVITIES_ENDPOINT)
    return response.data
}

export const createBusinessActivity = async (data) => {
    const response = await axios.post(BUSINESS_ACTIVITIES_ENDPOINT, data)
    return response.data
}

export const updateBusinessActivity = async (id, data) => {
    const response = await axios.put(BUSINESS_ACTIVITIES_ENDPOINT.concat(`id/${id}`), data)
    return response.data
}